export default "__VITE_ASSET__O7RCbB1G__"